import React, { useState, useEffect } from 'react';
import { WifiOff } from 'lucide-react';

const translations = {
  de: {
    backOnlineTitle: 'Wieder online',
    backOnlineMessage: 'Die Verbindung wurde wiederhergestellt',
    offlineTitle: 'Keine Internetverbindung',
    offlineMessage: 'Einige Funktionen sind möglicherweise nicht verfügbar'
  },
  en: {
    backOnlineTitle: 'Back Online',
    backOnlineMessage: 'Your connection has been restored',
    offlineTitle: 'No Internet Connection',
    offlineMessage: 'Some features may not work'
  }
};

const OfflineDetector = ({ language = 'de' }) => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showBanner, setShowBanner] = useState(!navigator.onLine);

  const t = translations[language];

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      // Keep banner visible for a moment when coming back online
      setTimeout(() => setShowBanner(false), 3000);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setShowBanner(true);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-1/2 md:-translate-x-1/2 md:max-w-md z-50 animate-slide-up">
      <div
        className={`rounded-2xl p-4 shadow-xl flex items-center gap-3 transition-colors ${
          isOnline
            ? 'bg-green-50 border-2 border-green-300'
            : 'bg-orange-50 border-2 border-orange-300'
        }`}
      >
        {isOnline ? (
          <>
            <div className="flex-shrink-0 text-2xl">✅</div>
            <div className="flex-1">
              <p className="font-semibold text-green-800">{t.backOnlineTitle}</p>
              <p className="text-sm text-green-700">{t.backOnlineMessage}</p>
            </div>
          </>
        ) : (
          <>
            <WifiOff className="flex-shrink-0 w-6 h-6 text-orange-600" />
            <div className="flex-1">
              <p className="font-semibold text-orange-800">{t.offlineTitle}</p>
              <p className="text-sm text-orange-700">{t.offlineMessage}</p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default OfflineDetector;
